import React from "react";
import { createClasses } from "@bloomberg/media-ui-core";
import { Change, Variant } from "@bloomberg/media-ui-markets";
import styles from "./styles.module.css";
import PlaceholderImage from "~components/Placeholder";

type FormatterFunction = (
  value: number,
  currency?: string,
  dp?: number
) => string | number;

type SummaryCellProps = {
  title: string;
  value?: number;
  percentChange?: number;
  currency?: string;
  variant?: "with-change" | "value";
  formatter?: FormatterFunction;
  isLoading?: boolean;
};

export default function SummaryCell(props: Readonly<SummaryCellProps>) {
  const {
    title,
    value,
    percentChange,
    currency,
    variant = "value",
    formatter,
    isLoading = false,
  } = props;

  if (value === undefined && !isLoading) {
    return null;
  }

  return (
    <div
      className={createClasses(styles.summaryCell, {
        [styles.withChange]: variant === "with-change",
      })}
    >
      <div className={styles.title}>
        {title}
        {currency && <div className={styles.currency}>({currency})</div>}
      </div>
      <div className={styles.valueContainer}>
        {isLoading ? (
          <div className={styles.placeholderWrapper}>
            <PlaceholderImage height={28} />
          </div>
        ) : (
          <>
            <span className={styles.value}>{formatter?.(value ?? 0)}</span>
            {variant === "with-change" && percentChange !== undefined && (
              <Change
                className={styles.change}
                percentChange={percentChange}
                variant={Variant.refresh2024}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
}
